import React, {useEffect} from "react";
import PageWrapper from '../components/PageWrapper';
import SubPageWrapper from '../components/SubPageWrapper';
import MyLi from '../components/MyLi';
import MyLink from '../components/MyLink';
import Typography from '@material-ui/core/Typography';

export default function Publication(props) {
    useEffect(() => {
        document.title = "Yonghui Liu - Publication"
    }, [])
    return (
        <PageWrapper showDivider={true} title="Publications">
            <SubPageWrapper title="Peer Reviewed Paper">    
                <MyLi>
                Daihang Chen, <b>Yonghui Liu</b>, Mingyi Zhou, Yanjie Zhao, Haoyu Wang, Shuai Wang, Xiao Chen, Tegawendé F Bissyandé, Jacques Klein, Li Li,
                LLM for Mobile: An Initial Roadmap.
                ACM Transactions on Software Engineering and Methodology (TOSEM 2025)
                {/* https://arxiv.org/pdf/2407.06573*/}
                </MyLi>   
                <MyLi>
                <b>Yonghui Liu</b>, Xiao Chen, Pei Liu, Jordan Samhi, Chunyang Chen, John Grundy, Li Li,
                Demystifying React Native Android Apps for Static Analysis.
                ACM Transactions on Software Engineering and Methodology (TOSEM 2024)
                {/* https://arxiv.org/pdf/2407.06573*/}
                </MyLi>  
                <MyLi>
                Yue Liu, Chakkrit Tantithamthavorn, <b>Yonghui Liu</b>, Li Li,                
                On the reliability and explainability of language models for program generation.
                ACM Transactions on Software Engineering and Methodology (TOSEM 2024)
                {/* https://dl.acm.org/doi/pdf/10.1145/3641540 */}
                </MyLi>  
                <MyLi>
                Yue Liu, Chakkrit Tantithamthavorn, <b>Yonghui Liu</b>, Patanamon Thongtanunam, Li Li,
                Automatically Recommend Code Updates: Are We There Yet?
                ACM Transactions on Software Engineering and Methodology (TOSEM 2024)
                {/* https://dl.acm.org/doi/pdf/10.1145/3678167 */}
                </MyLi>  


                <MyLi>                
                <b>Yonghui Liu</b>, Xiao Chen, Yue Liu, Pingfan Kong, Tegawende Bissyandé, Jacques Klein, Xiaoyu Sun, Li Li, Chunyang Chen and John Grundy,
                A Comparative Study between Android Phone and TV Apps.                             
                Automated Software Engineering Journal (ASEJ), 2025
                {/* https://arxiv.org/pdf/2407.06573*/}
                </MyLi>      
                
                <MyLi>
                Daihang Chen, <b>Yonghui Liu</b>, Mingyi Zhou, Yanjie Zhao, Haoyu Wang, Shuai Wang, Xiao Chen, Tegawendé F Bissyandé, Jacques Klein, Li Li,
                LLM for Mobile: An Initial Roadmap
                2030 Software Engineering (SE2030), 2024
                {/* https://arxiv.org/pdf/2407.06573*/}
                </MyLi>                  
                <MyLi>
                Haonan Chen, Daihang Chen, <b>Yonghui Liu</b>, Xiaoyu Sun, Li Li,
                Are Your Android App Analyzers Still Relevant?
                IEEE/ACM 11th International Conference on Mobile Software Engineering and Systems
                </MyLi>  
                
            {/* </SubPageWrapper>

            <SubPageWrapper title="2023"> */}
                <MyLi>
                Xiaoyu Sun, Xiao Chen, <b>Yonghui Liu</b>, John Grundy, Li Li,
                Taming android fragmentation through lightweight crowdsourced testing.
                IEEE Transactions on Software Engineering (TSE 2023)
                {/* https://arxiv.org/pdf/2304.04347 */}
                </MyLi>  

                <MyLi>
                <b>Yonghui Liu</b>, Xiao Chen, Pei Liu, John Grundy, Chunyang Chen, Li Li,
                Reunify: A step towards whole program analysis for react native android apps.
                2023 38th IEEE/ACM International Conference on Automated Software Engineering (ASE)
                {/* https://arxiv.org/pdf/2309.03524 */}
                </MyLi>  

                <MyLi>
                Haonan Hu, Yue Liu, Yanjie Zhao, <b>Yonghui Liu</b>, Xiaoyu Sun, Chakkrit Tantithamthavorn, Li Li,
                Detecting Temporal Inconsistency in Biased Datasets for Android Malware Detection.
                2023 38th IEEE/ACM International Conference on Automated Software Engineering Workshops (ASEW)
                {/* https://sunxiaobiu.github.io/papers/malware_temporal_inconsistency_issre23.pdf */}
                </MyLi>  
                
                <MyLi>
                Xiaoyu Sun, Xiao Chen, <b>Yonghui Liu</b>, John Grundy, Li Li,
                Taming android fragmentation through lightweight crowdsourced testing.
                the 38th IEEE/ACM International Conference on Automated Software Engineering (ASE Journal-First) 2023, 2023
                {/* https://sunxiaobiu.github.io/papers/CrowdsourcedTesting.pdf */}
                </MyLi>  
                
                <MyLi>
                Xiaoyu Sun, Xiao Chen, <b>Yonghui Liu</b>, John Grundy, Li Li,
                LazyCow: A Lightweight Crowdsourced Testing Tool for Taming Android Fragmentation.
                31st ACM Joint European Software Engineering Conference and Symposium on the Foundations of Software Engineering (FSE-tool 2023), 2023
                {/* https://sunxiaobiu.github.io/papers/CrowdsourcedTesting.pdf */}
                </MyLi>  
                
               
            {/* </SubPageWrapper>

            <SubPageWrapper title="2022">                   */}
                <MyLi>
                Pei Liu, Xiaoyu Sun, Yanjie Zhao, <b>Yonghui Liu</b>, John Grundy, Li Li,
                A first look at CI/CD adoptions in open-source android apps.
                2022 37th IEEE/ACM International Conference on Automated Software Engineering Workshops (ASEW), 2022
                {/* https://arxiv.org/pdf/2210.12581 */}
                </MyLi>   
            {/* </SubPageWrapper> */}
            
            {/* <SubPageWrapper title="2021">                 */}
                <MyLi>
                <b>Yonghui Liu</b>, Li Li, Pingfan Kong, Xiaoyu Sun, Tegawendé F Bissyandé,
                A first look at security risks of android tv apps.
                2021 36th IEEE/ACM International Conference on Automated Software Engineering Workshops (ASEW), 2021
                {/* https://orbilu.uni.lu/bitstream/10993/49671/1/AndroidTVApps-postprint.pdf */}
                </MyLi>                      
            {/* </SubPageWrapper> */}

            {/* <SubPageWrapper title="Peer Reviewed Journal"> */}               
            </SubPageWrapper>

        </PageWrapper>

    );

}
